export const transformToCdnUrl = (path: string): string => {
    return `${import.meta.env.VITE_APP_CDN_URL}/${path}`;
};
